export default {
  "wrapper": "_wrapper_1pwgsj",
  "account-option": "_account-option_1pwgsj",
  "account-label": "_account-label_1pwgsj",
  "account-balance": "_account-balance_1pwgsj"
};
